<template>
    <div class="module cloudhost"
         style="position: relative;">
        <helpinfo :helpData="helpData" />
        <envSelect @envId="envClick"></envSelect>
        <div class="module-container"
             style="margin-top:-17px;">
            <input ref="copyrelay"
                   v-model="copyId"
                   class="copy-el" />
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refreshTable">
                    <i class="icon-refresh-o-2"></i>
                </Button>
                <Button type="primary"
                        @click="createHost"
                        v-if="false"
                        slot="tootipL">
                    <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                </Button>
            </rcTable>
        </div>
        <!-- 查看日志 -->
        <Drawer :closable="true"
                class="log-drawer"
                width="650"
                :title="$t('查看日志')"
                v-model="logModal"
                @on-close="cancel">
            <div style="width:100%;height:100%;background: #242424;">
                <div v-if="logLoading"
                     style="">
                </div>
                <div v-else>
                    <div v-if="logs.length > 0">
                        <log :data="logs" />
                    </div>
                    <div v-if="logs.length === 0">
                        <div class="no-log"
                             style="color: #fff">{{$t('暂无日志')}}</div>
                    </div>
                </div>
            </div>
        </Drawer>
        <!-- 查看监控 -->
        <drawerMonitor v-if='monitorModal'
                       @onClose="monitorCancel"
                       :hostConfig='hostConfig'></drawerMonitor>
    </div>
</template>
<script>
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import log from '@c/basic/log'
import envSelect from '@c/basic/env'
import drawerMonitor from '@c/basic/cloudhost/drawermonitor'
import dropdownlist from '@c/basic/dropdownlist'
import remotelink from './components/remotelink'
import API from '@/service/api.js'
export default {
    name: 'hosts',
    components: {
        rcTable,
        helpinfo,
        log,
        drawerMonitor,
        envSelect
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('云主机'),
                showBack: false
            },
            copyId: null,
            quote: 'host',
            tableAttr: {
                source: {
                    type: 'get', // 'staticData'静态数据
                    url: this.urlFormat(API.HOSTS, false),
                    params: {
                        envId: sessionStorage.getItem('resourcesEnvId') || null,
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId
                    }
                },
                searchColumns: [
                    {
                        title: this.$t('名称'),
                        key: 'instanceNameLike'
                    },
                    {
                        title: this.$t('网络'),
                        key: 'networkNameLike'
                    },
                    {
                        title: this.$t('子网'),
                        key: 'subnetNameLike'
                    }
                ],
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: true,
                columnsChooseShow: true,
                referenceVal: 1525,
                columns: [
                    {
                        title: this.$t('名称') + '/ID',
                        key: 'id',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h(
                                    'div',
                                    [
                                        h(
                                            'div',
                                            [
                                                params.row.lockStatus === 'locked' &&
                                                h('span', {
                                                    attrs: {
                                                        title: `${this.$i18n.t('已被')}${params.row.lockUserEmail}${this.$i18n.t('锁定')}`
                                                    }
                                                }, [
                                                    h('Icon', {
                                                        props: {
                                                            type: 'ios-lock'
                                                        },
                                                        style: {
                                                            color: '#d67520'
                                                        }
                                                    })
                                                ]),
                                                h('a', {
                                                    class: {
                                                        'tbl-operate': true,
                                                        'rc-ellipsis': true
                                                    },
                                                    style: {
                                                        'max-width': 'calc(100% - 16px)',
                                                        display: 'inline-block',
                                                        'vertical-align': 'middle'
                                                    },
                                                    attrs: {
                                                        title: params.row.instanceName
                                                    },
                                                    on: {
                                                        click: () => {
                                                            this.hasPermission('CB0101') && this.toHostDetail(params.row)
                                                        }
                                                    }
                                                }, params.row.instanceName),
                                                h('Tooltip',
                                                    {
                                                        props: {
                                                            content: params.row.osName,
                                                            transfer: true,
                                                            theme: 'light'
                                                        },
                                                        style: {
                                                            display: params.row.osName && (params.row.osName.toLowerCase().indexOf('centos') > -1 || params.row.osName.toLowerCase().indexOf('redhat') > -1 || params.row.osName.toLowerCase().indexOf('ubuntu') > -1 || params.row.osName.toLowerCase().indexOf('windows') > -1) ? 'inline-block' : 'none'
                                                        }
                                                    },
                                                    [
                                                        params.row.osName && h('i', {
                                                            class: {
                                                                'ecs-icon-os-centos  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('centos') > -1,
                                                                'ecs-icon-os-ubuntu  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('ubuntu') > -1,
                                                                'ecs-icon-os-redhat  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('redhat') > -1,
                                                                'env-icon window-icon': params.row.osName.toLowerCase().indexOf('windows') > -1
                                                            }
                                                        })
                                                    ]
                                                )
                                            ]
                                        )]
                                ),
                                h(
                                    'div',
                                    {
                                        class: 'ellipsis',
                                        style: { width: '170px', color: '#666', paddingBottom: '5px' },
                                        attrs: {
                                            title: params.row.id
                                        }
                                    },
                                    params.row.id
                                ),
                                h(
                                    'Tooltip',
                                    {
                                        class: 'rc-tips copyId',
                                        style: { position: 'absolute', left: '175px', top: '17px', width: '15px' },
                                        props: {
                                            transfer: true,
                                            placement: 'top',
                                            theme: 'light',
                                            content: this.$t('复制ID')
                                        }
                                    },
                                    [
                                        h('Icon', {
                                            class: 'copy-icon',
                                            style: { color: '#1f68b3', 'font-size': '14px' },
                                            props: {
                                                type: 'ios-browsers-outline'
                                            },
                                            on: {
                                                click: () =>
                                                    this.copylink(
                                                        params.row.id
                                                    )
                                            }
                                        })
                                    ]
                                )
                            ]
                            )
                        }
                    },
                    {
                        key: 'envId',
                        title: this.$i18n.t('云环境'),
                        columnShow: true,
                        sortKey: 'cloudEnvType',
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { style: 'margin-right: 0;', class: this.envIcon(params.row.cloudEnvType) }),
                                h('span', { style: 'vertical-align: middle;', class: 'icon-text' }, params.row.cloudEnvName)
                            ])
                        }
                    },
                    {
                        title: this.$t('可用区'),
                        key: 'zone',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            return h('div', {
                                attrs: {
                                    title: params.row.zone
                                }
                            }, params.row.zone)
                        }
                    },
                    {
                        title: this.$i18n.t('实例类型'),
                        key: 'cpu',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 120,
                        resizable: true,
                        render: (h, params) => {
                            const s = `CPU:${params.row.cpu || 0}${this.$t('核')}、${this.$t('内存')}:${params.row.memory ? (params.row.memory / 1024).toFixed(2) : 0}GB`
                            return h('span', {
                                class: 'rc-ellipsis',
                                attrs: {
                                    title: s
                                }
                            }, s)
                        }
                    },
                    {
                        title: this.$i18n.t('IP地址'),
                        key: 'ipLike',
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            let s = ''
                            if (params.row.publicIp && params.row.innerIp) {
                                s = `(${this.$t('公')})${params.row.publicIp},(${this.$t('内')})${params.row.innerIp}`
                            } else if (params.row.publicIp) {
                                s = `(${this.$t('公')})${params.row.publicIp}`
                            } else if (params.row.innerIp) {
                                s = `(${this.$t('内')})${params.row.innerIp}`
                            }
                            return h('div', {
                                class: 'rc-ellipsis',
                                attrs: {
                                    title: s
                                }
                            }, [
                                h('span', { style: params.row.publicIp ? '' : 'display: none' }, '(' + this.$t('公') + ')' + params.row.publicIp + ' '),
                                h('span', { style: params.row.innerIp ? '' : 'display: none' }, '(' + this.$t('内') + ')' + params.row.innerIp)
                            ])
                        }
                    },
                    {
                        title: this.$t('登陆方式'),
                        key: 'remoteLoginType',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: false,
                        columnsChoosed: true,
                        width: 80,
                        resizable: true,
                        render: (h, params) => {
                            const str = params.row.remoteLoginType === 'ByPassword' ? this.$t('密码登录')
                                : params.row.remoteLoginType === 'ByKeypair' ? this.$t('密钥登录') : '--'
                            return h('span', { attrs: { title: str } }, str)
                        }
                    },

                    {
                        title: this.$t('状态'),
                        key: 'status',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        resizable: true,
                        width: 130,
                        className: 'ellipsis',
                        filters: [],
                        filterMultiple: false,
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', this.$t('状态')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'right', theme: 'light' }
                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('p', this.$t('创建失败的状态点击可查看详情'))])]
                                    )
                                ])
                        },
                        render: (h, params) => {
                            params.row.sshPort && (params.row.sshPort += '')
                            return h('instancestatus', {
                                class: 'rc-ellipsis',
                                props: {
                                    row: params.row,
                                    isNoPer: true,
                                    quote: this.quote
                                },
                                on: {
                                    refreshTable: () => {
                                        this.refreshTable()
                                    },
                                    viewTaskLog: () => {
                                        this.viewTaskLog(params.row)
                                    },
                                    viewNodeMonitor: () => {
                                        this.viewNodeMonitor(params.row)
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('计费类型'),
                        key: 'billingType',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        align: 'center',
                        render: (h, params) => {
                            const txt = params.row.instanceChargeType === 'PrePaid' ? this.$t('包年包月') : this.$t('按量计费')
                            const arr = [
                                h('p', {
                                    attrs: { title: txt }
                                }, txt
                                )
                            ]
                            if (params.row.instanceChargeType === 'PrePaid' && params.row.countdown && params.row.countdown !== null) {
                                let txtDay = ''
                                if (params.row.countdown >= 0 && this.$newTimeComparison(params.row.endTime)) {
                                    txtDay = params.row.countdown + this.$t('天后到期')
                                } else {
                                    txtDay = this.$t('已过期') + Math.abs(params.row.countdown) + this.$t('天')
                                }
                                arr.push(
                                    h('div', { style: { display: 'inline-block' } },
                                        [
                                            h('Tooltip', {
                                                props: { transfer: true, placement: 'right', theme: 'light' }
                                            }, [
                                                h('p', { class: 'txt-border' }, txtDay),
                                                h('div', { slot: 'content' }, [
                                                    h('p', this.$t('开始时间') + '：' + params.row.startTime || '--'),
                                                    h('p', this.$t('结束时间') + '：' + params.row.endTime || '--')
                                                ])]
                                            )
                                        ])
                                )
                            }
                            return h('div', arr)
                        }
                    },
                    {
                        title: this.$t('所属项目'),
                        key: 'orgName',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => h('span', { attrs: { title: params.row.orgName } }, params.row.orgName)
                    },
                    {
                        title: this.$t('操作'),
                        width: 230,
                        tooltip: false,
                        fixed: 'right',
                        render: (h, params) => {
                            const arr = []
                            // 操作中间状态不能任何操作
                            const status = ['starting', 'deleting', 'setting', 'stopping', 'creating'].includes(params.row.status)
                            arr.push(h(dropdownlist, {
                                props: {
                                    operateConfig: this.configBtn(params.row)
                                },
                                style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                                on: { event: (type) => { this.operate(type, params.row) } }
                            }))
                            return h('div', { class: 'tbl-btn-div' }, [
                                h(remotelink, {
                                    props: {
                                        entry: 'list',
                                        info: params.row,
                                        isDisabled: !this.hasPermission('CB0102') || status
                                    }
                                }),
                                h('a', { style: { display: this.checkBtnStatus('start', params.row) ? 'none' : 'inline-block' }, class: { disabled: status || !this.hasPermission('CB0102') }, on: { click: () => !status && this.hasPermission('CB0102') && this.instanceAction('start', params.row) } }, this.$t('启动')),
                                h('a', { style: { display: this.checkBtnStatus('stop', params.row) ? 'none' : 'inline-block' }, class: { disabled: status || !this.hasPermission('CB0103') }, on: { click: () => !status && this.hasPermission('CB0103') && this.instanceAction('stop', params.row) } }, this.$t('停止')),
                                h('a', { class: { disabled: status || this.checkBtnStatus('restart', params.row) || !this.hasPermission('CB0104') }, on: { click: () => !status && this.hasPermission('CB0104') && this.instanceAction('restart', params.row) } }, this.$t('重启')),
                                h('div', {
                                    style: { display: 'inline-block' },
                                    class: 'tbl-operate'
                                }, arr)
                            ])
                        }
                    }
                ]
            },
            logModal: false,
            logLoading: false,
            logs: [],
            monitorModal: false
        }
    },
    created () {
        this.init()
        if (this.quote === 'source') { // 资源组调用该组件时接口替换，并且屏蔽相应查询条件
            this.tableAttr.source.url = this.urlFormat(API.GET_RESGROUP_HOSTS, false, [this.$route.params.id])
            this.tableAttr.source.params = {}
            for (const item of this.tableAttr.columns) {
                if (item.key === 'ipLike' || item.key === 'tagNamesLike' || item.key === 'status') {
                    item.disabledSearch = true
                }
            }
        }
        // 网络查询
        if (this.$route.query.vpcName) {
            this.tableAttr.searchDefaultValueList.push({
                key: 'networkNameLike',
                name: this.$route.query.vpcName,
                title: this.$t('网络'),
                value: this.$route.query.vpcName
            })
        }
        if (this.$route.query.subnetName) {
            this.tableAttr.searchDefaultValueList.push({
                key: 'subnetNameLike',
                name: this.$route.query.subnetName,
                title: this.$t('子网'),
                value: this.$route.query.subnetName
            })
        }
        if (this.$route.query.hostName) {
            this.tableAttr.searchDefaultValueList.push({
                key: 'instanceNameLike',
                name: this.$route.query.hostName,
                title: this.$t('名称'),
                value: this.$route.query.hostName
            })
        }
        // 查询保持
        if (this.tableName && sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableName]) {
            this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableName]
        }
        const sts = this.$route.query.expireDay + ''
        if (sts) {
            this.tableAttr.searchDefaultValueList = this.tableAttr.searchDefaultValueList.filter((item) => {
                return item.key !== 'expireDay'
            })
        }
        this.hostType === 'BareMetal' && this.hide()
    },
    mounted () {
        this.websoctRefesh()
    },
    methods: {
        // 创建
        createHost () {
            // 创建数据
            // this.$router.push({
            //     path: '/mgt/host/create'
            // })
        },
        // 复制剪切板
        copylink (id) {
            this.copyId = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        },
        hide () {
            this.tableAttr.columns.splice(2, 1)
        },
        // 初始化
        init () {
            this.instanceType = this.$route.query.instanceType
            this.axios.get(this.urlFormat(`${API.GET_CODE_DATA}/RES_VM_STATUS`, true)).then(res => {
                const index = this.tableAttr.columns.findIndex(col => col.key === 'status')
                this.tableAttr.columns[index].filters = res.map(item => {
                    return { label: item.codeDisplay, value: item.codeValue }
                })
                this.noChange = true
                this.$refs.rcTable && this.$refs.rcTable.initSearchColumns()
            })
        },
        // 云环境查询
        envClick (data) {
            this.tableAttr.source.params.envId = data
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        // 主机详情
        toHostDetail (row) {
            this.$router.push({
                path: `/mgt/host/${row.id}/detail`,
                query: { envType: row.cloudEnvType, quote: this.quote, hostType: this.hostType }
            })
        },
        // websoct
        websoctRefesh () {
            let refresh = this.$refs.rcTable && this.$refs.rcTable.refreshTable
            this.instanceWs = this.$websocket('/topic/vm', (result) => {
                refresh = refresh || this.$refs.rcTable.refreshTable
                refresh(null, null, result.body)
            })
        },
        checkBtnStatus (type, rowData) { // 按钮控制逻辑
            const status = rowData.status
            switch (type) {
                // 禁用启动  启动中(starting) 正常(running) 创建失败(create_failure)
                case 'start': // 启动
                    if (status !== 'stopped' && status !== 'suspended') {
                        return true
                    }
                    return false
                case 'restart': // 重启
                    if (status !== 'running') {
                        return true
                    }
                    return false
                case 'stop': // 停止
                    if (status !== 'running' && status !== 'suspended') {
                        return true
                    }
                    return false
                default:
                    return false
            }
        },
        instanceAction (type, rowData) {
            if (this.checkBtnStatus(type, rowData)) return
            const actionName = type === 'start' ? this.$t('启动') : type === 'restart' ? this.$t('重启') : type === 'stop' ? this.$t('停止') : ''
            const content = this.$t(`您确定${actionName}所选实例吗？`)
            const ids = rowData.id
            this.$Modal.confirm({
                content,
                title: actionName,
                onOk: () => {
                    this.axios.put(this.urlFormat(`${API.HOSTS}/action/${type}?ids=${ids}&&isStopCharging=false`, false))
                        .then(() => {
                            this.refreshTable()
                        })
                }
            })
        },
        // 生成更多按钮
        configBtn: function (obj) {
            const status = ['starting', 'deleting', 'setting', 'stopping', 'creating'].includes(obj.status)
            const btnConfig = [
                { value: 'resourceChange', btnName: this.$t('变更配置'), display: true, disabled: status || !this.hasPermission('CB0114') || obj.status !== 'stopped' }
            ]
            if (obj.instanceChargeType === 'PostPaid') {
                // 按量计费-删除
                btnConfig.push({ value: 'delete', btnName: this.$t('删除'), display: true, disabled: status || !this.hasPermission('CB0105') })
            } else {
                // 包年包月-退订
                btnConfig.push({ value: 'unsubscribe', btnName: this.$t('退订'), display: true, disabled: status || !this.hasPermission('CB0115') })
            }
            return JSON.stringify(btnConfig)
        },
        // 执行操作(事件派发)
        operate: function (operateType, data) {
            const status = ['starting', 'deleting', 'setting', 'stopping', 'creating'].includes(data.status)
            if (status) {
                return false
            }
            switch (operateType) {
                case 'delete':

                    this.deleteFun(data)
                    break
                case 'resourceChange':
                    this.resourceChangeFun(data)
                    break
                case 'unsubscribe':
                    this.unsubscribeFun(data)
                    break
            }
        },
        // 删除
        deleteFun (row) {
            if (!this.hasPermission('CB0105')) {
                return false
            }
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('您确定删除当前云主机吗？'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.DELETE_SERVICE_UNSUBSCRIBE_ID, false, [row.id])).then(res => {
                        this.refreshTable()
                    })
                }
            })
        },
        // 变更规格
        resourceChangeFun (row) {
            if (!this.hasPermission('CB0114')) {
                return false
            }
            // 包年包月
            this.$router.push({
                path: '/mgt/resourcechange',
                query: { id: row.id, type: 'host', envType: row.cloudEnvType, link: '/mgt/cloudhost' }
            })
        },
        // 退订
        unsubscribeFun (row) {
            if (!this.hasPermission('CB0115')) {
                return false
            }
            this.$router.push({
                path: '/mgt/unsubscribe',
                query: { id: row.id, link: '/mgt/cloudhost' }
            })
        },
        // 刷新
        refreshTable () {
            this.$refs.rcTable.refreshTable()
        },
        viewTaskLog (item) {
            this.logModal = true
            this.logLoading = true
            this.axios.get(this.urlFormat(API.GET_HOST_LOGS + '/' + item.id, false)).then((res) => {
                this.logs = res || []
                this.logLoading = false
                // 订阅websocket
                this.logSubscribe = this.$websocket('/topic/' + item.id, (result) => {
                    this.logs.push(result.body)
                })
            })
        },
        viewNodeMonitor (item) {
            if ((item.status === 'running' || item.status === 'stopped') && item.cloudEnvType) {
                this.hostConfig = {
                    id: item.id,
                    name: item.instanceName,
                    type: item.cloudEnvType,
                    envId: item.cloudEnvId
                }
                this.monitorModal = true
            }
        },
        cancel () {
            if (this.logSubscribe) {
                this.logSubscribe.unsubscribe()
            }
            this.logModal = false
        },
        // 关闭监控抽屉
        monitorCancel () {
            this.monitorModal = false
        }
    },
    beforeDestroy () {
        // 取消websocket订阅
        if (this.instanceWs) {
            this.instanceWs.unsubscribe()
        }
    }
}
</script><style lang="less" scoped>
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
.renew-content .ivu-spin-text {
    display: block !important;
    margin-left: -12px;
    margin-top: 5px;
}
.ivu-dropdown-item {
    padding: 5px 16px;
}
.log-drawer {
    div.ivu-drawer-header {
        background: #242424;
        border-bottom: 1px solid #383737;
        .ivu-drawer-header-inner {
            color: #fff;
        }
    }
    div.ivu-drawer-body {
        padding: 0;
        .no-log {
            line-height: 300px;
            background-color: transparent;
            color: #ccc;
            text-align: center;
            font-size: 20px;
        }
    }
}
</style>
